// Decoders for sparkjs's native packed-splat words (4×u32 per splat), as emitted
// by the GPU lift (src/ogs/inference/wgsl/lift_pass2.wgsl). Kept in one
// place so the decode stays bit-matched to the encoder:
//
//   word0 = uR | uG<<8 | uB<<16 | uA<<24      (rgba8; uA = sigmoid(opacity)*255)
//   word1 = pack2x16float(x, y)               (half(x) low16 | half(y) high16)
//   word2 = half(z) low16 | quatX<<16 | quatY<<24
//   word3 = scales + quatZ
//
// Used by IsaacModel's autoframe when the lifter runs in packedMode (no SoA
// out.positions to read). Pure, no GPU — unit-tested in tests/unit/packedSplat.test.mjs.

/** IEEE-754 binary16 (u16) → JS number. */
export function halfToFloat(h) {
  const s = (h & 0x8000) >> 15
  const e = (h & 0x7c00) >> 10
  const f = h & 0x03ff
  if (e === 0) return (s ? -1 : 1) * Math.pow(2, -14) * (f / 1024)
  if (e === 0x1f) return f ? NaN : (s ? -Infinity : Infinity)
  return (s ? -1 : 1) * Math.pow(2, e - 15) * (1 + f / 1024)
}

/** Decode splat i's position into [x, y, z]. `packed` is the 4-u32-per-splat array. */
export function decodePackedPosition(packed, i) {
  const w1 = packed[i * 4 + 1], w2 = packed[i * 4 + 2]
  return [
    halfToFloat(w1 & 0xffff),
    halfToFloat((w1 >>> 16) & 0xffff),
    halfToFloat(w2 & 0xffff),
  ]
}

/** Splat i's quantized alpha byte (= round(sigmoid(opacity_logit) * 255)). */
export function packedAlphaByte(packed, i) {
  return (packed[i * 4 + 0] >>> 24) & 0xff
}
